// client/src/components/tendermaker/BidWorkspacePage.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { tmBidCreate, tmBidList } from "./tendermakerApi";
import Layout from "../Layout";


export default function BidWorkspacePage() {
  const [bids, setBids] = useState([]);
  const [title, setTitle] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function refresh() {
    const r = await tmBidList();
    setBids(r.data || []);
  }

  useEffect(() => {
    refresh().catch((e) => setErr(String(e)));
  }, []);

  async function create() {
    setBusy(true);
    setErr("");
    try {
      const out = await tmBidCreate(title || "Untitled Bid");
      setTitle("");
      await refresh();
      // optional: jump user to bid details page (we keep it simple: analyzer can pick it)
      alert(`Bid created: ${out.bidId}`);
    } catch (e) {
      setErr(String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout>
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: 16 }}>
      <h2 style={{ marginBottom: 6 }}>TenderMaker — Bid Workspace</h2>
      <div style={{ color: "#6b7280", marginBottom: 16 }}>
        Create a bid and upload multiple bid-related PDFs. Analyzer treats them as one bid.
      </div>

      {err ? <div style={{ color: "crimson", marginBottom: 12 }}>{err}</div> : null}

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, padding: 12, marginBottom: 16 }}>
        <div style={{ fontWeight: 900, marginBottom: 8 }}>Create a Bid</div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Example: GeM Bid 2026 - UPS Battery"
            style={{ padding: 10, borderRadius: 10, border: "1px solid #e5e7eb", minWidth: 420 }}
            disabled={busy}
          />
          <button
            onClick={create}
            disabled={busy}
            style={{ padding: "10px 14px", borderRadius: 10, border: "1px solid #e5e7eb", background: "#fafafa", fontWeight: 800 }}
          >
            {busy ? "Creating…" : "Create Bid"}
          </button>
        </div>
      </div>

      <div style={{ fontWeight: 900, marginBottom: 8 }}>Your bids</div>
      <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden" }}>
        {bids.map((b) => (
          <div key={b.id} style={{ padding: 12, borderTop: "1px solid #f3f4f6" }}>
            <div style={{ fontWeight: 800 }}>{b.title}</div>
            <div style={{ color: "#6b7280", fontSize: 13 }}>bidId: {b.id}</div>
            <div style={{ marginTop: 8 }}>
              <Link to={`/tendermaker/bids/${b.id}`} style={{ textDecoration: "none", fontWeight: 700 }}>
                Open Upload Page →
              </Link>
            </div>
          </div>
        ))}
        {bids.length === 0 ? <div style={{ padding: 12, color: "#6b7280" }}>No bids yet.</div> : null}
      </div>
    </div>
    </Layout>
  );
}
